import React, { useState } from 'react';

import Sidebar from '../../../v3/Sidebar/Sidebar';
import Footer from '../../Footer/Footer';
import './AppLayout.scss';

const AppLayoutV3 = ({ children }: React.PropsWithChildren) => {
  const [openMenuTablet, setOpenMenuTablet] = useState(false);

  const handleMenuTablet = (status: boolean): void => {
    setOpenMenuTablet(status);
  };

  return (
    <div className="app-layout" data-experience="new">
      <Sidebar openMenuTablet={openMenuTablet} closeMenuTablet={() => handleMenuTablet(false)} />
      <div className="app-content">
        {children}
        <Footer dashboard={true} />
      </div>
    </div>
  );
};

export default AppLayoutV3;
